'use strict'

function keepOnlyPortfolioInformation(project) {
  return {
    id: project.id,
    name: project.name,
    priority: project.priority,
    isStarted: project.isStarted,
    isPaused: project.isPaused,
    isStopped: project.isStopped,
    phase: project.phase,
    projectType: project.projectType,
    overallStatus: project.overallStatus,
    portfolio: project.portfolio,
    category: project.category,
    location: project.location,
    department: project.department,
    state: project.state,
    benefits: project.benefits,
    time: project.time,
    cost: project.cost,
    quality: project.quality,
    scope: project.scope,
    risk: project.risk!==undefined ? {
      status: project.risk.status,
      content: project.risk.content
    } : undefined,
    statusDate: project.statusDate,
    reportedBy: project.reportedBy,
    requestedStageException: project.requestedStageException,
    requestedStageTransition: project.requestedStageTransition,
    recommendedProjectClosure : project.recommendedProjectClosure,
    requestedPhase: project.requestedPhase,
    currentPhase: project.currentPhase,
    isProgramme: project.isProgramme,
    isProduct: project.isProduct,
    isRelease: project.isRelease,
    programme: project.programme,
    releases: project.isProduct && project.releases!==undefined
      ? project.releases
          .filter(release=>release.active)
          .map(release=>({
            name:release.name,
            active:release.active,
            activated: release.activated
          }))
      : undefined
  }
}

function strippedTenant(tenant, includeStakeholders ) {
  return tenant!==undefined ? Object.assign({},tenant,{
    projects: false && tenant.projects!==undefined ?
      tenant.projects.map(project=>
        keepOnlyPortfolioInformation(project)
      ) : undefined,
    stakeholders: includeStakeholders===true ? tenant.stakeholders : undefined,
    lessons: undefined
  }) : undefined;
}

function strippedProject(project) {
  return project!==undefined
    ? Object.assign({},project,{
      plan: project.plan!==undefined
        ? Object.assign({},project.plan,{
          history: project.plan.history!==undefined
            ? project.plan.history
              .map(item=>Object.assign({},item,{
                stages: undefined
              }))
            : undefined
          })
        : undefined
    })
    : undefined;
}

function stripHistory(project) {
  return process.env.OPTIMIZE_PROJECT_HISTORY==="true" ? Object.assign({},project,{
    plan: project.plan!==undefined
      ? Object.assign({},project.plan,{
          history: undefined
        })
      : undefined
  }) : project;
}

module.exports.keepOnlyPortfolioInformation=keepOnlyPortfolioInformation;
module.exports.strippedTenant=strippedTenant;
module.exports.strippetProject=strippedProject;
module.exports.stripHistory=stripHistory;



// WEBPACK FOOTER //
// ./app/utils/performance.js